import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';

type PageSkipButtonProps = {
	skipUrl: string;
	skipLabel: string;
	/** Left unset when an ancestor intercepts the click, so the tap is never handled twice. */
	onSkipClick?: () => void;
	/**
	 * The design system's `loading` only swaps in a spinner on the link variant — it adds no ARIA and
	 * does not block activation — so the busy/disabled state is spelled out here too.
	 */
	loading?: boolean;
};

export const PageSkipButton: React.FC<PageSkipButtonProps> = ({ skipUrl, skipLabel, onSkipClick, loading = false }) => (
	<Button
		as="a"
		href={skipUrl}
		onClick={onSkipClick}
		loading={loading}
		aria-busy={loading}
		aria-disabled={loading}
		data-qa="skip-link"
		variant="tertiary"
		size="large"
		className="self-center"
	>
		{skipLabel}
	</Button>
);
